import React from 'react';

const IcoLogoNovemberfive = props => (
  <svg data-name="Layer 1" viewBox="0 0 100.63 100.62" {...props}>
    <title>logo-novemberfive</title>
    <path d="M71.59 57.9L63.2 53V31.91h-8.38v16.3l-8.4-4.85V31.91h-8.37v6.62l-10.49-6.06a4.19 4.19 0 0 0-6.28 3.63v33.23h8.37v-26l8.4 4.85v21.15h8.37V53l8.4 4.85v11.48h8.38v-6.61l10.49 6.06A4.19 4.19 0 0 0 80 65.15V31.91h-8.41z" />
    <path d="M96.69 31.16a50.15 50.15 0 1 0 3.93 19.46 49.83 49.83 0 0 0-3.93-19.46zm-16.63 48.9a41.63 41.63 0 0 1-58.87-58.87 41.63 41.63 0 1 1 58.87 58.87z" />
  </svg>
);

export default IcoLogoNovemberfive;



// WEBPACK FOOTER //
// /opt/build/repo/src/app/components/icons/IcoLogoNovemberfive.js